"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
function ObjectiveSkeleton({ noBorder, addClass }) {
    return (react_1.default.createElement("div", { className: `objective-skeleton ${noBorder ? 'noborder' : ''} ${addClass}`, "data-cy": "objective-skeleton" },
        react_1.default.createElement("div", { className: "objective-header" },
            react_1.default.createElement("div", { className: "profile-picture" },
                react_1.default.createElement(Shimmer_1.default, { circle: true, width: "40px", height: "40px" }))),
        react_1.default.createElement("div", { className: "objective-content-left" },
            react_1.default.createElement("div", { className: "content-name" },
                react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "60%", height: "16px" })),
            react_1.default.createElement("div", { className: "content-detail" },
                react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "10%", height: "8px" }),
                react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "25%", height: "8px" }))),
        react_1.default.createElement("div", { className: "objective-content-right" },
            react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "20%", height: "16px" }),
            react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "20%", height: "16px" }),
            react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "30%", height: "16px" })),
        react_1.default.createElement("div", { className: "objective-content-check" },
            react_1.default.createElement(Shimmer_1.default, { customClass: "rounded", width: "24px", height: "24px" }))));
}
exports.default = ObjectiveSkeleton;
